import { render, staticRenderFns } from "./CreateOptionModal.vue?vue&type=template&id=48e2cedf&"
import script from "./CreateOptionModal.vue?vue&type=script&lang=ts&"
export * from "./CreateOptionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports